module.exports = __webpack_public_path__ + "img/about-image-1.e99447f6.jpg";